export default __webpack_public_path__ + "static/media/DSC02210.65a99746.jpeg";